// extracted by mini-css-extract-plugin
export default {"topSpacer":"spacer_topSpacer__e5gKm","bottomSpacer":"spacer_bottomSpacer__SXQa6","midSpacer":"spacer_midSpacer__4ww0r"};